module.exports = __webpack_public_path__ + "img/logo_circle_blue.87bd0daa.png";